import { Injectable } from '@angular/core';
import { WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { IProgressResponseItem } from '@shared/model/project';
import { retry } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  private _baseUrl: string = `${environment.wssUrl}`;
  private ws!: WebSocketSubject<IProgressResponseItem>;

  constructor() {}

  public joinProject(projectId: number) {
    this.ws = new WebSocketSubject(`${this._baseUrl}/progress_bar/${projectId}/`);
    return this.ws.pipe(retry());
  }

  public leaveProject() {
    if (this.ws) {
      this.ws.complete();
    }
  }
}
